// https://github.com/mui-org/material-ui/blob/v1-beta/packages/material-ui-icons/tpl/SvgIcon.js
import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

const SvgIconCustom = global.__MUI_SvgIcon__ || SvgIcon;

let CSIcon = props => (
  <SvgIconCustom {...props}>
    <path d="M0 9v7c0 1.66 1.34 3 3 3h3v-8H2V9c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1H9v2h6c1.66 0 3-1.34 3-3V9A9 9 0 0 0 0 9z" />
  </SvgIconCustom>
);

CSIcon = pure(CSIcon);
CSIcon.muiName = 'SvgIcon';

export default CSIcon;



// WEBPACK FOOTER //
// ../ui-components/components/Icons/cs-icon.jsx